import { useCallback } from 'react';
import { useMutation } from '@ts-core/lib/apollo';

import { sendMessageMutation, SendMessageMutationVariables } from '../graphql/mutations/sendMessageMutation';

interface MessageActionsHookInput {
  courseId: string;
}

interface MessageActionsHookResult {
  onSendMessage: (title: string, content: string, studentIds: string[], onSuccess?: () => void) => void;
  sendMessageLoading: boolean;
}

export default function useMessageActions(input: MessageActionsHookInput): MessageActionsHookResult {
  const { courseId } = input;

  const [sendMessage, { loading: sendMessageLoading }] = useMutation<any, SendMessageMutationVariables>(sendMessageMutation, { notifySuccess: true });
  const onSendMessage = useCallback(
    (title: string, content: string, studentIds: string[], onSuccess?: () => void) => {
      sendMessage({
        variables: {
          courseId,
          input: {
            message: {
              title,
              content,
            },
            students: studentIds,
          },
        },
      }).then(onSuccess);
    },
    [courseId, sendMessage]
  );

  return {
    onSendMessage,
    sendMessageLoading,
  };
}
